<template>
  <Layout>
    <div style="width: 100%; margin-top: 55px">
      <Loading v-if="loading" />
      <q-card>
        <EmptyValue
          name="reports"
          style="background: #fff !important"
          v-if="!loading && reports.length === 0"
        />
      </q-card>
      <div class="report-container">
        <q-card
          class="report-card"
          v-for="(report, index) in reports"
          :key="index"
        >
          <div :class="report.status" class="report-status">
            {{ firstCharCapital(report.status)[0] }}
            <q-tooltip>Status :{{ firstCharCapital(report.status) }}</q-tooltip>
          </div>
          <div class="report-content">
            <div class="widthable">
              This report created at
              <span class="report-date">
                <i class="far fa-calendar"></i
                >{{ usaDateFormatter(report.created_at) }}
              </span>
              and includes
              <span style="margin:0px 2.5px;font-weight:bold;color:#666"
                >({{ report.items.length }})</span
              >
              vehicle.
            </div>
            <div class="report-setting">
              <q-icon
                @click="modalHandler(report.id)"
                style="cursor:pointer"
                color="grey-7"
                name="fas fa-times"
              ></q-icon>
              <q-icon
                style="cursor:pointer"
                :color="report.status !== 'finished' ? 'grey-7' : 'positive'"
                name="fas fa-info-circle"
                @click="report.status === 'finished' && getDetail(report.id)"
              />
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <q-dialog v-model="show">
      <q-card style="width: 320px">
        <div class="logout-text">
          Are you sure to delete this report?
        </div>
        <div class="logout-actions" @click="close">
          <div class="cancel-button">
            Cancel
          </div>
          <div class="logout-button" @click="removeHandler">
            APPLY
          </div>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="report">
      <q-card style="max-width:1000px;width:100%">
        <HistoryReport
          v-for="report in current.items"
          :key="report.id"
          :report="report"
        />
        <div class="logout-actions" @click="report = false">
          <div class="cancel-button">
            Cancel
          </div>
          <div class="logout-button" @click="exportAsXls">
            EXPORT
          </div>
        </div>
      </q-card>
    </q-dialog>
  </Layout>
</template>
<script>
import Layout from "../components/Layout";
import EmptyValue from "../components/EmptyValue";
import Loading from "../components/Loading";
import HistoryReport from "@/components/HistoryReport";
import axios from "@/axios";
export default {
  data() {
    return {
      id: null,
      show: false,
      loading: false,
      interval: null,
      current: "",
      report: false,
    };
  },
  components: { Layout, EmptyValue, Loading, HistoryReport },
  mounted() {
    this.$store.state.history.reports.length === 0 && this.getReports(true);
    this.infiniteReports();
  },
  computed: {
    reports: {
      get() {
        const status = this.$store.state.history.status;
        return !status
          ? this.$store.state.history.reports
          : this.$store.state.history.reports.filter(
              (report) => report.status === status.value
            );
      },
      set(val) {
        this.$store.commit("history/SET_REPORTS", val);
      },
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async exportAsXls() {
      try {
        const {
          data,
        } = await axios.get(
          `reports/history-report/${this.current.id}/export`,
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const name = await this.nameGenerator();
        link.setAttribute("download", `${name}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log(error);
      }
    },
    async nameGenerator() {
      let name = "cosmosboard_history_report";
      var currentdate = new Date();
      var datetime =
        currentdate.getDate() +
        "_" +
        (currentdate.getMonth() + 1) +
        "_" +
        currentdate.getFullYear() +
        "_" +
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes() +
        ":" +
        currentdate.getSeconds();
      name += datetime;
      return name;
    },
    async getDetail(id) {
      try {
        const { data } = await axios.get(`reports/history-report/${id}`);
        this.current = { ...data };
        this.report = true;
      } catch (error) {}
    },
    async removeHandler() {
      this.show = false;
      try {
        const {
          data: { message },
        } = await axios.delete(`reports/history-report/${this.id}`);
        this.$q.notify({
          message,
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive",
        });
        this.reports = this.reports.filter((report) => report.id !== this.id);
      } catch (error) {
        const { message } = error.response.data;
        this.$q.notify({
          message: message[0],
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative",
        });
      }
    },
    close() {
      this.show = false;
    },
    modalHandler(id) {
      this.id = id;
      this.show = true;
    },
    infiniteReports() {
      this.interval = setInterval(
        async () => await this.getReports(),
        1000 * 60
      );
    },
    usaDateFormatter(val) {
      return new Date(val).toLocaleDateString("en-US");
    },
    firstCharCapital(val) {
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
    async getReports(loading = false) {
      try {
        if (loading) this.loading = true;
        const {
          data: { items },
        } = await axios.get("reports/history-reports", {
          params: { per: 10000 },
        });
        this.$store.commit("history/SET_REPORTS", items);
      } catch (error) {
        console.log(error);
      } finally {
        if (loading) this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comma {
  &::after {
    content: " , ";
  }
  &:last-child::after {
    content: " ";
  }
}
.bolder {
  font-weight: 500;
  margin-right: 5px;
}
.working {
  background: orange;
  height: 50px;
  width: 50px;
  border-radius: 50% !important;
}
.failed {
  background: #f44336;
  height: 50px;
  width: 50px;
  border-radius: 50% !important;
}
.finished {
  background: #21ba45;
  height: 50px;
  width: 50px;
  border-radius: 50% !important;
}
.report-container {
  display: flex;
  flex-flow: row wrap;
  .report-card {
    margin: 0px 10px;
    padding: 15px;
    margin-bottom: 10px;
    display: flex;
    flex-flow: row nowrap;
    flex: 0 1 calc(50% - 20px);
    .report-status {
      align-items: center;
      display: flex;
      justify-content: center;
      font-size: 20px;
      color: #fff;
      flex: 0 0 50px;
    }
    .report-content {
      justify-content: space-between;
      align-items: center;
      display: flex;
      flex: 1;
      flex-flow: row nowrap;
      font-size: 14px;
      .widthable {
        flex: 0 1 calc(100% - 50px);
        margin-left: 10px;
      }
      .report-date {
        font-weight: bold;
        color: #666;
        margin-left: 5px;
        i {
          margin-right: 5px;
        }
      }
      .report-type {
        display: flex;
        flex-flow: row nowrap;
        font-weight: bold;
        .strech-me {
          flex: 1;
        }
      }
      .report-locations {
        font-weight: 300;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* number of lines to show */
        -webkit-box-orient: vertical;
        span {
          &::after {
            content: " , ";
          }
          &:last-child::after {
            content: " ";
          }
        }
      }
      .report-dates {
        display: flex;
        flex-flow: row wrap;
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .report-container {
    flex: 1;
    flex-flow: column nowrap;
  }
}
</style>
